import './homeMobileCategories.less';

const homeMobileCategories = {

}

export { homeMobileCategories };


// WEBPACK FOOTER //
// ./components/homeMobileCategories/homeMobileCategories.js